"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enums = require("../enums");
var _lotteryAssistant = require("@/api/lotteryAssistant");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var winStatusMap = {
  0: '待开奖',
  1: '未中奖',
  2: '待领取',
  3: '已领取'
};
var _default = exports.default = {
  name: 'ActivityUsers',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    activityId: {
      type: [String, Number],
      default: ''
    },
    op: {
      type: String,
      default: 'edit'
    }
  },
  data: function data() {
    return {
      loading: false,
      grid: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6
      },
      winStatusMap: winStatusMap,
      total: 0,
      list: [],
      prizeOptions: [],
      queryParams: {
        page: 1,
        limit: 20,
        userName: '',
        phoneNumber: '',
        lotteryCode: '',
        minFreezeBalance: '',
        excludePrizeIds: []
      },
      multipleSelection: [],
      checkIds: [],
      statistics: {
        total: 0,
        prizeList: []
      },
      box: {
        show: false,
        prizeId: ''
      }
    };
  },
  computed: {
    gridSpan: function gridSpan() {
      return 24 / (this.statistics.prizeList.length + 1);
    }
  },
  watch: {
    value: {
      handler: function handler(newV) {
        if (newV) {
          this.init();
        }
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    init: function init() {
      this.getPrizeOptions();
      this.getRecordNum();
      this.resetQuery();
    },
    handleClose: function handleClose() {
      this.$emit('input', false);
      this.prizeOptions = [];
      this.statistics.total = 0;
      this.statistics.prizeList = [];
      this.list = [];
    },
    formatter: function formatter(value, key) {
      if (key === 'prizeType') {
        var target = _enums.prizeTypeOptions.find(function (item) {
          return item.value === value;
        });
        return target ? target.label : value;
      }
      return '-';
    },
    getPrizeOptions: function getPrizeOptions() {
      var _this = this;
      (0, _lotteryAssistant.lotteryActivityPrizeListApi)(this.activityId).then(function (data) {
        _this.prizeOptions = data || [];
      });
    },
    getRecordNum: function getRecordNum() {
      var _this2 = this;
      (0, _lotteryAssistant.lotteryActivityRecordNumApi)(this.activityId).then(function (data) {
        _this2.statistics.total = data.totalParticipants;
        _this2.statistics.prizeList = data.prizeStatistics || [];
      });
    },
    getList: function getList() {
      var _this3 = this;
      this.loading = true;
      var params = _objectSpread(_objectSpread({}, this.queryParams), {}, {
        activityId: this.activityId
      });
      (0, _lotteryAssistant.lotteryActivityRecordListApi)(params).then(function (res) {
        var list = (res.list || []).map(function (item) {
          item.winsFlag = item.redeemCode ? 1 : 0;
          return item;
        });
        _this3.list = list;
        _this3.total = res.total || 0;
        _this3.loading = false;
      }).catch(function (error) {
        console.error('API错误：', error);
        _this3.loading = false;
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.queryParams = {
        page: 1,
        limit: 20,
        activityId: '',
        phoneNumber: '',
        redeemCode: '',
        minFreezeBalance: '',
        excludePrizeIds: []
      };
      this.handleQuery();
    },
    handleSizeChange: function handleSizeChange(val) {
      //选择多少条数据
      this.queryParams.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      this.checkedIds = this.multipleSelection.map(function (item) {
        return item.recordId;
      });
    },
    showPrizeModal: function showPrizeModal() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.box.prizeId = '';
      this.box.show = true;
    },
    setPrize: function setPrize() {
      var _this4 = this;
      this.loading = true;
      var params = {
        recordIds: this.checkedIds,
        prizeId: this.box.prizeId
      };
      (0, _lotteryAssistant.lotteryActivityRecordUpdateApi)(params).then(function () {
        _this4.$message.success('设置成功');
        _this4.getRecordNum();
        _this4.getList();
        _this4.closePrizeModal();
      }).finally(function () {
        _this4.$message.error('设置失败');
        _this4.loading = false;
      });
    },
    cancelPrize: function cancelPrize(row) {
      var _this5 = this;
      this.loading = true;
      var params = {
        recordId: row.recordId
      };
      (0, _lotteryAssistant.lotteryActivityRecordCancelApi)(params).then(function () {
        _this5.$message.success('取消成功');
        _this5.getRecordNum();
        _this5.getList();
      }).catch(function () {
        _this5.$message.error('取消失败');
      }).finally(function () {
        _this5.loading = false;
      });
    },
    closePrizeModal: function closePrizeModal() {
      this.box.show = false;
    }
  }
};